/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import JsController from '../js-controller';


export default (app: App) => {

    const controller = new JsController(app, 'Event Details');
    controller.addMountFunction(() => {
        mountEventDetailsComponent(controller);
    })

    return controller.init();
}

export function mountEventDetailsComponent( controller: JsController ) {
    const eventDetails = document.querySelectorAll<HTMLElement>('.event-details')
    for(const eventDetail of eventDetails){

        const readMoreButton = eventDetail.querySelector<HTMLElement>('.read-more-button')
        const readLessButton = eventDetail.querySelector<HTMLElement>('.read-less-button')
        const eventIntroduction = eventDetail.querySelector<HTMLElement>('.event-introduction')



        if(readMoreButton && eventIntroduction && readLessButton){
            if(eventIntroduction?.clientHeight < 200){
                readMoreButton?.classList.add('hidden')
                eventIntroduction.classList.add('no-after','mb-9')
            }

            const expandText = () => {
                readMoreButton.classList.add('hidden')
                readLessButton.classList.remove('hidden')

                if (eventIntroduction.classList.contains('max-h-[200px]')) {
                    eventIntroduction.classList.remove('max-h-[200px]')
                }
                else {
                    eventIntroduction.classList.add('max-h-full')  
                }

                eventIntroduction.classList.add('mb-9')
                eventIntroduction.classList.add('no-after')
            }

            const collapseText = () => {
                readLessButton.classList.add('hidden')
                readMoreButton.classList.remove('hidden')

                if (eventIntroduction.classList.contains('max-h-[200px]')) {
                    eventIntroduction.classList.remove('max-h-full') 
                }
                else {
                    eventIntroduction.classList.add('max-h-[200px]')
                }

                eventIntroduction.classList.remove('mb-9')

                eventIntroduction.classList.remove('no-after')
            }
            
            controller.addListener(readMoreButton, "click", expandText)
            controller.addListener(readLessButton, "click", collapseText)
        }
    }
}
